// extracted by mini-css-extract-plugin
module.exports = {"position":"Position_position__7eW5_"};